import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styled, { withTheme } from 'styled-components'
import MediaQuery from 'react-responsive'
import { inject, observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'

import { ArrowBigIcon } from '../Icons/ArrowBigIcon'
import { colors } from '../../styles/colors'
import { formatedPriceObject } from '../../utils/formatedPrice'
import {
  CategoryIconDefault,
  CategoryIcons,
} from '../Icons/CategoryIcons/CategoryIcons'
import ExpandedArticle from './ExpandedArticle'
import Badge from 'react-bootstrap/Badge'
import useMountEffect from '../../utils/hooks/useMountEffect'
import { AddToBasketButton } from '../Buttons/AddToBasketButton'
import { Form, Alert } from 'react-bootstrap'
import FavoriteItem from '../Favorite/FavoriteItem'

const StyledTr = styled.tr`
  border-top: 1px solid #e0e0e0;
  &:hover {
    background-color: rgba(0, 0, 0, 0.075);
    cursor: pointer;
  }

  td {
    vertical-align: middle;
  }
`

const StyledListRow = styled.div`
  padding: 6px;
  border-top: 1px solid #e0e0e0;
  &:hover {
    // background-color: rgba(0, 0, 0, 0.075);
    cursor: pointer;
  }
  @media (max-width: 992px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  @media (max-width: 650px) {
    flex-direction: column;
    justify-content: center;
  }
`

const StyledFormBlock = styled.div`
  display: block;
  width: 100%;

  @media (max-width: 992px) {
    display: block;
  }
`

const StyledName = styled.div`
  margin-left: 1rem;
  flex-basis: 50%;
`
const StyledArticleDescription = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.textColorB80};

  svg {
    margin-top: -2px;
  }

  @media (max-width: 425px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 10px;

    > div {
      margin-bottom: 0.5rem;
    }

    ${StyledName} {
      margin-left: 0;
    }
  }
`

const StyledInfosArticle = styled.div`
  display: flex;
  align-items: start;
  @media (max-width: 992px) {
    padding: 20px;
  }
  // @media (max-width: 768px) {
  //   flex-direction: column;
  //   padding: 20px;
  // }
  @media (max-width: 569px) {
    flex-direction: row;
    margin-top: 10px;
  }
  @media (max-width: 426px) {
    flex-direction: column;
    align-items: center;
  }
`

const StyledProductImgWrap = styled.div`
  box-shadow: 0 0 15px rgb(0 0 0 / 20%);
  background: white;
  width: ${(props) => (props.smallImage ? '50px' : '150px')};
  height: ${(props) => (props.smallImage ? '50px' : '150px')};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;

  svg {
    width: 100%;
    height: 100%;
    opacity: 0.3;
  }
`

const StyledProductImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`
const StyledBadge = styled(Badge)`
  border-radius: 0px 0px 0px 0px;
  margin: 5px 5px;
`
const ProductListItem = inject(
  'productListStore',
  'productDetailsStore'
)(
  observer((props) => {
    const {
      t,
      theme,
      smallImage,
      catalogOnly,
      to,
      columns,
      shoppingBasketArticle,
      iconType,
      productListStore,
      expandedOnDefault,
      productDetailsStore,
      articleId,
      shouldHidePricesAndPoints,
    } = props
    const navigate = useNavigate()
    const [expandArticle, setExpandArticle] = useState(expandedOnDefault)
    const [invalidQuantity, setInvalidQuantity] = useState(false)
    const [imageError, setImageError] = useState(false)
    // const [visibleSuccess, setVisibleSuccess] = useState(false)

    const shoppingBasketArticleId = shoppingBasketArticle.id

    const currentProductObj =
      productListStore.productObj[shoppingBasketArticle.id]
    const CategoryIcon =
      iconType && CategoryIcons[iconType]
        ? CategoryIcons[iconType]
        : CategoryIconDefault
    const articlePrice =
      expandArticle && currentProductObj && currentProductObj.price
        ? currentProductObj.price
        : formatedPriceObject(shoppingBasketArticle.pricePerItem || {})
    const hasAddToBasketErrors =
      currentProductObj &&
      currentProductObj.addToBasketErrors &&
      currentProductObj.addToBasketErrors.length
        ? true
        : false
    const amountToOrder =
      currentProductObj && currentProductObj.articleAvailability
        ? currentProductObj.articleAvailability.amountToOrder
        : shoppingBasketArticle.articleAvailability.amountToOrder

    const withArticleColumn = columns.includes('article')
    const withPriceColumn = columns.includes('price')
    const withMaxColumn = columns.includes('max')
    const withCurrentColumn = columns.includes('current')
    const withAmountToOrderColumn = columns.includes('amountToOrder')

    useMountEffect(() => {
      if (!currentProductObj) {
        ;(async function () {
          productListStore.initProductObject(shoppingBasketArticle)
          await productListStore.loadOrderableVariants(shoppingBasketArticleId)
          productListStore.loadAllVariantsQuantities(shoppingBasketArticleId)
          productListStore.loadArticlePrices(shoppingBasketArticleId)
          productListStore.loadArticleConfiguration(shoppingBasketArticleId)
          await productListStore.loadLocalStorehouses(shoppingBasketArticleId)
        })()
      }
    })
    useEffect(() => {
      if (hasAddToBasketErrors) {
        setExpandArticle(true)
      }
    }, [hasAddToBasketErrors])

    useEffect(() => {
      if (productDetailsStore.scrollRef === articleId) {
        let element = document.querySelector(`[data-id="${articleId}"]`)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        productDetailsStore.setScrollRef(null)
      }
    }, [articleId, productDetailsStore])

    const shouldShowExpanded =
      currentProductObj && currentProductObj.variants?.length > 0

    const handleClickRow = () => {
      sessionStorage.setItem('scrollPosition', window.scrollY.toString())
      sessionStorage.setItem(
        'lastViewedProduct',
        shoppingBasketArticle.article.id.toString()
      )

      const articleWithDefaults = {
        ...shoppingBasketArticle,
        articleAvailability: shoppingBasketArticle.articleAvailability || {},
        categoryAvailability: shoppingBasketArticle.categoryAvailability || {},
      }

      productDetailsStore.setShoppingBasketArticle(articleWithDefaults)
      if (catalogOnly) {
        navigate(to)
      } else if (!shouldShowExpanded) {
        productDetailsStore.setScrollRef(shoppingBasketArticle.article.id)
        navigate(productDetailsStore.getProductToUrl(shoppingBasketArticle))
      } else {
        setExpandArticle((prev) => !prev)
      }
    }
    const handleChangeQuantity = (e, shoppingBasketArticleId) => {
      productListStore.handleChangeQuantity(e, shoppingBasketArticleId)
      const remainingQuantity =
        currentProductObj.maximumQuantity -
        currentProductObj.articleAvailability.amountToOrder
      if (
        currentProductObj.maximumQuantity !== null &&
        e.target.value > remainingQuantity
      ) {
        setInvalidQuantity(true)
      } else {
        setInvalidQuantity(false)
      }
    }

    const ArticleDescription = () => (
      <StyledArticleDescription data-id={articleId}>
        {!catalogOnly &&
        currentProductObj &&
        currentProductObj.variants &&
        currentProductObj.variants.length ? (
          <ArrowBigIcon variant={expandArticle ? 'down' : 'right'} />
        ) : null}
        <div className='d-flex flex-column'>
          {props.badge && (
            <StyledBadge variant='primary'>{props.badge}</StyledBadge>
          )}
          <StyledProductImgWrap smallImage={smallImage}>
            {shoppingBasketArticle.article.image &&
            shoppingBasketArticle.article.image.url &&
            !imageError ? (
              <StyledProductImg
                src={shoppingBasketArticle.article.image.url}
                alt=''
                onError={() => setImageError(true)}
              />
            ) : (
              <CategoryIcon color={theme.primaryColor} className={iconType} />
            )}
          </StyledProductImgWrap>
        </div>
        <StyledName>
          <div>{shoppingBasketArticle.article.displayName}</div>
          <small className='text-uppercase'>
            {t('inventory:articleNr')}:
            {shoppingBasketArticle.article.articleNumber}
          </small>
          <div>
            {shoppingBasketArticle.article.aliases?.map((alias) => (
              <small key={alias.id}>
                {alias.aliasType}: {alias.displayName || '-'}
              </small>
            ))}
          </div>
          {(shoppingBasketArticle?.article?.unit?.displayName ??
            shoppingBasketArticle?.article?.unit?.isoCode) && (
            <div>
              <small>
                {t('unit')}:&nbsp;
                {shoppingBasketArticle?.article?.unit?.displayName ??
                  shoppingBasketArticle?.article?.unit?.isoCode}
              </small>
            </div>
          )}
        </StyledName>
      </StyledArticleDescription>
    )

    return (
      <>
        <MediaQuery minWidth={993}>
          <StyledTr data-id={articleId} onClick={handleClickRow}>
            {withArticleColumn ? (
              <td
                data-toggle='tooltip'
                data-placement='right'
                title={t('productDetail:clickForArticleDetails')}
              >
                <ArticleDescription />
              </td>
            ) : null}
            {withPriceColumn ? (
              !shouldHidePricesAndPoints ? (
                <td>{articlePrice}</td>
              ) : (
                <td></td>
              )
            ) : null}
            {withMaxColumn ? (
              <td
                data-toggle='tooltip'
                data-placement='right'
                title={t('productDetail:clickForArticleDetails')}
              >
                {shoppingBasketArticle.articleAvailability.maxAmount || 0}
              </td>
            ) : null}
            {withCurrentColumn ? (
              <td
                data-toggle='tooltip'
                data-placement='right'
                title={t('productDetail:clickForArticleDetails')}
              >
                {shoppingBasketArticle.articleAvailability.currentAmount || 0}
              </td>
            ) : null}
            {withAmountToOrderColumn ? (
              <td
                data-toggle='tooltip'
                data-placement='right'
                title={t('productDetail:clickForArticleDetails')}
              >
                {amountToOrder > 0 ? `+${amountToOrder}` : amountToOrder}
              </td>
            ) : null}
            {catalogOnly || (currentProductObj &&
            currentProductObj.variants &&
            currentProductObj.variants.length) ? null : (
              <td onClick={(e) => e.stopPropagation()}>
                {/* Prevent click from bubbling up */}
                {currentProductObj ? (
                  <Form.Control
                    className='mb-2'
                    type='number'
                    placeholder='1'
                    value={currentProductObj.selectedQuantity || ''}
                    onChange={(e) =>
                      handleChangeQuantity(e, shoppingBasketArticleId)
                    }
                    min={currentProductObj.minimumQuantity}
                    max={currentProductObj.maximumQuantity}
                    step={currentProductObj.packageSize}
                    isInvalid={invalidQuantity}
                    title=''
                  />
                ) : null}
                <AddToBasketButton
                  buttonText={t('productDetail:addToBasketButton')}
                  shoppingBasketArticle={shoppingBasketArticle}
                  onClick={() => {
                    // Check if variants exist and navigate if no variants
                    if (
                      currentProductObj &&
                      currentProductObj.variants &&
                      currentProductObj.variants.length > 0
                    ) {
                      // Navigate to product details page if no variants
                      if (
                        productListStore.productObj[shoppingBasketArticle.id]
                      ) {
                        navigate(
                          productDetailsStore.getProductToUrl(
                            shoppingBasketArticle
                          )
                        )
                      } else {
                        console.error(
                          `Product object for ID ${shoppingBasketArticle.id} is not initialized.`
                        )
                      }
                    } else {
                      productListStore.handleAddToBasket(
                        shoppingBasketArticle.id
                      )
                    }
                  }}
                  className='mb-2 w-100'
                  variant={'primary'}
                  loadingText={t('productDetail:buttonWaitText')}
                  isLoading={
                    currentProductObj
                      ? currentProductObj.addToBasketIsLoading
                      : false
                  }
                  title={null}
                />
                {productDetailsStore.app.uiStore
                  .allowFavoriteArticleCatalogForOrdering && (
                  <FavoriteItem articleId={shoppingBasketArticle.article.id} />
                )}
              </td>
            )}
          </StyledTr>
          {currentProductObj &&
          currentProductObj.addToBasketSuccess &&
          currentProductObj.variants &&
          currentProductObj.variants.length === 0 ? (
            <Alert variant='success' className='w-100'>
              {t('productDetail:productAddedSuccesfullyToBasket')}
            </Alert>
          ) : null}

          {currentProductObj &&
          currentProductObj.addToBasketErrors.length &&
          currentProductObj.variants &&
          currentProductObj.variants.length === 0
            ? currentProductObj.addToBasketErrors.map((error, errorIndex) => (
                <Alert key={errorIndex} variant='danger' className='w-100'>
                  {error.msg}
                </Alert>
              ))
            : ''}

          {expandArticle &&
          currentProductObj &&
          currentProductObj.variants &&
          currentProductObj.variants.length ? (
            <>
              <tr>
                <td colSpan='5' className='ps-5'>
                  <ExpandedArticle
                    shoppingBasketArticle={shoppingBasketArticle}
                  />
                </td>
              </tr>
            </>
          ) : null}
        </MediaQuery>

        <MediaQuery maxWidth={992}>
          <StyledListRow
            className='w-100'
            onClick={() => {
              sessionStorage.setItem(
                'scrollPosition',
                window.scrollY.toString()
              )
              sessionStorage.setItem(
                'lastViewedProduct',
                shoppingBasketArticle.article.id.toString()
              )

              // PREPARE article object like ProductCard does
              const articleWithDefaults = {
                ...shoppingBasketArticle,
                articleAvailability:
                  shoppingBasketArticle.articleAvailability || {},
                categoryAvailability:
                  shoppingBasketArticle.categoryAvailability || {},
              }

              productDetailsStore.setShoppingBasketArticle(articleWithDefaults)
              if (catalogOnly) {
                navigate(to)
              } else if (!shouldShowExpanded) {
                productDetailsStore.setScrollRef(
                  shoppingBasketArticle.article.id
                )
                navigate(
                  productDetailsStore.getProductToUrl(shoppingBasketArticle)
                )
              } else {
                setExpandArticle((prev) => !prev)
              }
            }}
          >
            <ArticleDescription />
            <StyledInfosArticle>
              {withPriceColumn && !shouldHidePricesAndPoints && (
                <div className='mx-3'>
                  <b>{t('price')}:</b> {articlePrice}
                </div>
              )}
              {withMaxColumn && (
                <div className='mx-3'>
                  <b>{t('productsOverview:max')}:</b>
                  {shoppingBasketArticle.articleAvailability.maxAmount || 0}
                </div>
              )}
              {withCurrentColumn && (
                <div className='mx-3'>
                  <b>{t('productsOverview:current')}:</b>
                  {shoppingBasketArticle.articleAvailability.currentAmount || 0}
                </div>
              )}
              {withAmountToOrderColumn ? (
                <div className='mx-3'>
                  <b>{t('productsOverview:amountInBasket')}:</b>
                  {amountToOrder > 0 ? `+${amountToOrder}` : amountToOrder}
                </div>
              ) : null}
              {/* <hr /> */}
            </StyledInfosArticle>
            {catalogOnly || (currentProductObj &&
            currentProductObj.variants &&
            currentProductObj.variants.length) ? null : (
              <StyledFormBlock>
                {currentProductObj ? (
                  <Form.Control
                    className='my-2'
                    type='number'
                    placeholder='1'
                    value={currentProductObj.selectedQuantity || ''}
                    onChange={(e) =>
                      handleChangeQuantity(e, shoppingBasketArticleId)
                    }
                    min={currentProductObj.minimumQuantity}
                    max={currentProductObj.maximumQuantity}
                    step={currentProductObj.packageSize}
                    isInvalid={invalidQuantity}
                  />
                ) : null}

                <AddToBasketButton
                  buttonText={t('productDetail:addToBasketButton')}
                  shoppingBasketArticle={shoppingBasketArticle}
                  onClick={() => {
                    sessionStorage.setItem(
                      'scrollPosition',
                      window.scrollY.toString()
                    )
                    sessionStorage.setItem(
                      'lastViewedProduct',
                      shoppingBasketArticle.article.id.toString()
                    )

                    // PREPARE article object like ProductCard does
                    const articleWithDefaults = {
                      ...shoppingBasketArticle,
                      articleAvailability:
                        shoppingBasketArticle.articleAvailability || {},
                      categoryAvailability:
                        shoppingBasketArticle.categoryAvailability || {},
                    }

                    productDetailsStore.setShoppingBasketArticle(
                      articleWithDefaults
                    )
                    // Check if variants exist and navigate if no variants
                    if (
                      currentProductObj &&
                      currentProductObj.variants &&
                      currentProductObj.variants.length > 0
                    ) {
                      // Navigate to product details page if no variants
                      if (
                        productListStore.productObj[shoppingBasketArticle.id]
                      ) {
                        navigate(
                          productDetailsStore.getProductToUrl(
                            shoppingBasketArticle
                          )
                        )
                      } else {
                        console.error(
                          `Product object for ID ${shoppingBasketArticle.id} is not initialized.`
                        )
                      }
                    } else {
                      productListStore.handleAddToBasket(
                        shoppingBasketArticle.id
                      )
                    }
                  }}
                  className='mb-2 w-100'
                  variant='primary'
                  loadingText={t('productDetail:buttonWaitText')}
                  isLoading={
                    currentProductObj
                      ? currentProductObj.addToBasketIsLoading
                      : false
                  }
                />
                {productDetailsStore.app.uiStore
                  .allowFavoriteArticleCatalogForOrdering && (
                  <FavoriteItem articleId={shoppingBasketArticle.article.id} />
                )}
              </StyledFormBlock>
            )}
            {currentProductObj &&
            currentProductObj.addToBasketSuccess &&
            currentProductObj.variants &&
            currentProductObj.variants.length === 0 ? (
              <Alert variant='success' className='w-100'>
                {t('productDetail:productAddedSuccesfullyToBasket')}
              </Alert>
            ) : null}

            {currentProductObj &&
            currentProductObj.addToBasketErrors.length &&
            currentProductObj.variants &&
            currentProductObj.variants.length === 0
              ? currentProductObj.addToBasketErrors.map((error, errorIndex) => (
                  <Alert key={errorIndex} variant='danger' className='w-100'>
                    {error.msg}
                  </Alert>
                ))
              : ''}
          </StyledListRow>
          {expandArticle &&
          currentProductObj &&
          currentProductObj.variants &&
          currentProductObj.variants.length ? (
            <>
              <ExpandedArticle shoppingBasketArticle={shoppingBasketArticle} />
            </>
          ) : null}
        </MediaQuery>
      </>
    )
  })
)

export default withTheme(withTranslation()(ProductListItem))
